@if (isLoading) {
  <div class="flex min-h-full flex-1 items-center justify-center px-10 py-6 text-lWhite">
    <l-spinner />
  </div>
} @else {
  <main class="mx-auto mt-24 flex w-full max-w-[69rem] flex-1 flex-col px-4 pt-6 sm:px-10 xl:max-w-none">
    <header class="mb-10 flex flex-col items-start gap-3">
      <h1 class="text-5xl font-bold text-lWhite">Perfil</h1>
      <p class="text-lSecondary">Edite suas informações pessoais</p>
    </header>

    <section class="flex flex-col gap-6">
      <!-- Banner -->
      <div class="relative h-52 overflow-hidden rounded-3xl">
        <img
          src="assets/svg/profile-header-center.svg"
          alt="gradiente"
          class="absolute left-[calc(50%+20px)] top-0 block h-full w-[1116px] max-w-none -translate-x-1/2 xl:hidden"
        />

        <img
          src="assets/svg/profile-header.svg"
          alt="gradiente"
          class="absolute left-0 top-0 hidden h-full w-[1664px] max-w-none xl:block"
        />
      </div>

      <section class="flex flex-col gap-4 xl:flex-row">
        <aside
          class="relative flex w-full shrink-0 flex-col overflow-visible rounded-3xl xl:w-[29rem]"
        >
          <div class="absolute inset-0 overflow-hidden rounded-3xl" aria-hidden="true">
            <img
              src="assets/svg/profile-menu.svg"
              alt=""
              class="absolute inset-y-0 left-0 hidden h-full w-[29rem] max-w-none object-fill xl:block"
            />

            <img
              src="assets/svg/profile-menu-small.svg"
              alt=""
              class="absolute left-1/2 top-0 block h-auto w-[64rem] max-w-none -translate-x-1/2 xl:hidden"
            />

            <!-- O SVG pequeno tem altura fixa: abaixo do recorte do avatar o fundo é sólido para cobrir cards mais altos -->
            <div class="absolute inset-x-0 bottom-0 top-24 bg-lGray900 xl:hidden"></div>
          </div>

          <div
            class="absolute left-1/2 top-[-6.5rem] z-10 h-44 w-44 -translate-x-1/2 rounded-full bg-lGray700 xl:top-[-6rem]"
          >
            <l-avatar
              [name]="userName || 'Usuário'"
              [imageUrl]="userAvatarUrl"
              sizeClass="h-full w-full text-5xl"
            />

            <input
              #avatarInput
              type="file"
              accept="image/*"
              class="hidden"
              (change)="onAvatarSelected($event)"
            />

            <button
              type="button"
              aria-label="Alterar foto de perfil"
              class="absolute inset-0 flex items-center justify-center rounded-full bg-black/60 text-white transition-opacity"
              [class.opacity-100]="isProfileEditing"
              [class.cursor-pointer]="isProfileEditing"
              [class.opacity-0]="!isProfileEditing"
              [class.pointer-events-none]="!isProfileEditing"
              (click)="openAvatarPicker(avatarInput)"
            >
              <l-icon class="!text-6xl">edit</l-icon>
            </button>
          </div>

          <div class="relative z-10 flex h-full flex-col px-2 pb-6 pt-24 xl:pt-20">
            <div class="flex flex-col items-center gap-1 px-4 py-6 text-center">
              <p class="max-w-full break-words text-2xl font-bold text-lWhite">{{ userName }}</p>
              <p class="max-w-full break-all text-xs text-lSecondary">{{ userEmail }}</p>
            </div>

            <div class="mx-2 mt-6 flex divide-x divide-lGray700 rounded-xl bg-lSecondary/10 px-2 py-4">
              <div class="flex flex-1 flex-col gap-1 px-2">
                <span class="text-xs text-lSecondary">Concluídos</span>
                <span class="text-2xl text-lWhite">{{ completedCount }}</span>
              </div>

              <div class="flex flex-1 flex-col gap-1 px-2">
                <span class="text-xs text-lSecondary">Em andamento</span>
                <span class="text-2xl text-lWhite">{{ inProgressCount }}</span>
              </div>

              <div class="flex flex-1 flex-col gap-1 px-2">
                <span class="text-xs text-lSecondary">Pendentes</span>
                <span class="text-2xl text-lWhite">{{ pendingCount }}</span>
              </div>
            </div>

            <nav
              class="mx-2 mt-4 flex flex-col gap-1"
              aria-label="Menu principal do perfil"
            >
              <button
                type="button"
                class="flex items-center gap-3 rounded-xl px-4 py-3 text-left transition-colors hover:bg-lSecondary/10 hover:text-lWhite"
                [ngClass]="
                  activeMenu === profileMenuEnum.PERSONAL_INFO
                    ? 'bg-lSecondary/10 text-lWhite'
                    : 'text-lSecondary'
                "
                (click)="setActiveMenu(profileMenuEnum.PERSONAL_INFO)"
              >
                <l-icon icon="person" />
                <span class="text-sm font-medium">Informações pessoais</span>
              </button>

              <button
                *lHasPermission="certificatesPermission"
                type="button"
                class="flex items-center gap-3 rounded-xl px-4 py-3 text-left transition-colors hover:bg-lSecondary/10 hover:text-lWhite"
                [ngClass]="
                  activeMenu === profileMenuEnum.CERTIFICATES
                    ? 'bg-lSecondary/10 text-lWhite'
                    : 'text-lSecondary'
                "
                (click)="setActiveMenu(profileMenuEnum.CERTIFICATES)"
              >
                <l-icon icon="emoji_events" />
                <span class="text-sm font-medium">Certificados</span>
              </button>

              <button
                type="button"
                class="flex items-center gap-3 rounded-xl px-4 py-3 text-left transition-colors hover:bg-lSecondary/10 hover:text-lWhite"
                [ngClass]="
                  activeMenu === profileMenuEnum.CHANGE_PASSWORD
                    ? 'bg-lSecondary/10 text-lWhite'
                    : 'text-lSecondary'
                "
                (click)="setActiveMenu(profileMenuEnum.CHANGE_PASSWORD)"
              >
                <l-icon icon="lock" />
                <span class="text-sm font-medium">Alterar senha</span>
              </button>
            </nav>

            <hr class="mx-2 my-2 border-lGray700" />

            <nav
              class="mx-2 flex flex-col gap-1"
              aria-label="Menu de políticas do perfil"
            >
              <button
                type="button"
                class="flex items-center gap-3 rounded-xl px-4 py-3 text-left transition-colors hover:bg-lSecondary/10 hover:text-lWhite"
                [ngClass]="
                  activeMenu === profileMenuEnum.PRIVACY_POLICIES
                    ? 'bg-lSecondary/10 text-lWhite'
                    : 'text-lSecondary'
                "
                (click)="setActiveMenu(profileMenuEnum.PRIVACY_POLICIES)"
              >
                <l-icon icon="person" />
                <span class="text-sm font-medium">Políticas de privacidade</span>
              </button>
            </nav>
          </div>
        </aside>

        <div class="min-w-0 flex-1">
          @if (activeMenu === profileMenuEnum.PERSONAL_INFO) {
            <l-profile-information
              [user]="user"
              [avatarFile]="pendingAvatarFile"
              (editingChange)="onProfileEditingChange($event)"
              (userChange)="onUserChange($event)"
            />
          } @else if (activeMenu === profileMenuEnum.CHANGE_PASSWORD) {
            <l-profile-password />
          } @else if (activeMenu === profileMenuEnum.CERTIFICATES) {
            <l-profile-certificates [completedCourses]="completedUserCourses" />
          }
        </div>
      </section>
    </section>
  </main>
}